module.exports = __webpack_public_path__ + "img/img4.704a5a3f.png";